<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible && !approvalCancelVisible && !approvalBackVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">客户名称</span>
            <el-input
              v-model="listQuery.customerCompanyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
              v-model="listQuery.businessNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务品牌</span>
            <el-input
              v-model="listQuery.businessBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
              v-model="listQuery.businessName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
              v-model="listQuery.businessModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">订单号码</span>
            <el-input
              v-model="listQuery.customerOrderNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票号码</span>
            <el-input
              v-model="listQuery.invoiceNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">部分开票、待开票</span></span>
            <span class="status-item"><span class="status-square" style="background-color: gray;"></span><span class="status-text">已作废</span></span>
            <span class="status-item"><span class="status-square" style="background-color: #F3D03C;"></span><span class="status-text">待确认作废</span></span>
            <span class="status-item"><i class="iconfont icon-tubiao-40" /><span class="status-text">有备注信息</span></span>
            <span class="status-item"><i class="iconfont icon-tubiao-40 cell-blue" /><span class="status-text">开票资料有修改</span></span>
          </span>
        </div>
      </div>
      <div class="split-table-layout">
        <!-- 主表区域 -->
        <div
          class="split-pane-top vue-grid-item"
          :style="{ height: isSubMenuCollapse ? '100%' : `${topHeight}px` }"
        >
          <TableList
              :ref="rf => { if (rf) tableDataRef[0] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :showSummary="true"
              :isShowPagination="false"
              :handleDefaultWidth="140"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              style="height:calc(100% );overflow:hidden;"
              :tableRowClassName="tableCellClassName"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:no="scope">
                <el-tooltip
                  effect="dark"
                  :content="scope.row.mark"
                  placement="top-start"
                  v-if="scope.row.mark"
                >
                  <i class="iconfont icon-tubiao-40"></i>
                </el-tooltip>
                <span v-if="scope.row.applyCancelStatus === 1" class="color-cancle">{{scope.row.applyCancelStatus === 1 ? '申请作废' : ''}} </span>
                <span v-if="scope.row.status === 2" class="color-cancle">{{scope.row.status === 2 ? '申请退回' : ''}} </span>
                <span :class="tableCellClassName(scope)">{{scope.row.no}} </span>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
        </div>

        <!-- 水平交互分割线 -->
        <TableSplitter
          v-if="!isSubMenuCollapse && tabList.length"
          @drag-start="handleSplitterDragStart"
          @drag-move="handleSplitterDragMove"
          @drag-end="handleSplitterDragEnd"
        />

        <!-- 子表区域 -->
        <div
          v-show="!isSubMenuCollapse && tabList.length"
          class="split-pane-bottom"
          :style="{ height: `${bottomHeight}px` }"
        >
          <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <TraceInfo v-if="activeTab === 3" ref="TraceInfo" :id="activeId" api="invoice"/>
              <BusinessInfo v-if="activeTab === 2" ref="TraceInfo" :id="activeId" api="invoice"/>
              <LogisticTable :sendFlag="0" TableName="TABLE_DELIVERY_INFO" permissionName="LOGISTIC_INFO" v-if="activeTab === 1" ref="LogisticTable" :sourceId="activeId" :sourceType="3"/>
        </div>
      </div>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      :api="'invoice'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
    <!-- 登记发票 -->
    <el-dialog
      v-if="dengjiVisible"
      v-model="dengjiVisible"
      width="80%"
      title=""
    >
      <div class="form-title mb-10">
        <span class="label blue">开</span>
        <span class="left">开票信息</span>
      </div>
      <el-descriptions>
        <el-descriptions-item label="金额：">{{ $currency(activeRow.amount)}}</el-descriptions-item>
        <el-descriptions-item label="公司抬头：">{{ activeRow.title }}</el-descriptions-item>
        <el-descriptions-item label="税率：">{{ activeRow.rate }}%</el-descriptions-item>
        <el-descriptions-item label="客户公司名称：">{{ activeRow.customerCompanyName }}</el-descriptions-item>
        <el-descriptions-item label="客户发票抬头：">{{ activeRow.titleName }}</el-descriptions-item>
        <el-descriptions-item label="税号：">{{ activeRow.taxId }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="开户行及账号：">{{ activeRow.bank }}{{ activeRow.account }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="地址、电话：">{{ activeRow.registeredAddress }}{{ activeRow.phone }}
        </el-descriptions-item>
      </el-descriptions>
      <el-descriptions>
        <el-descriptions-item label="备注："><span style="color:red">{{ activeRow.mark }}</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="form-title mt-20 mb-20">
        <span class="label yellow">开</span>
        <span class="left">开票记录</span>
      </div>
      <el-table :data="DJTableData" border style="width: 100%;" max-height="400px" >
        <el-table-column label="发票号码" prop="no" min-width="120"/>
        <el-table-column label="发票代码" prop="code" min-width="120"/>
        <el-table-column label="发票校验码" prop="checkCode" min-width="180"/>
        <el-table-column label="开票日期" prop="date" min-width="120"/>
        <el-table-column label="发票金额" prop="amount" align="right" min-width="120">
          <template #default="{ row }">
            <span :style="{ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' }">
              {{ $currency(row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="发票类型" prop="type" width="110" align="center">
          <template #default="{ row }">
            <el-tag :type="row.type === '退票' || row.amount < 0 ? 'warning' : 'success'" size="small">
              {{ row.type === '退票' || row.amount < 0 ? '退票' : '正常发票' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="登记日期" prop="createTime" min-width="140"/>
        <el-table-column label="状态" prop="status" width="110" align="center">
          <template #default="{ row }">
            <el-tag :type="row.status === 0 ? 'info' : 'success'" size="small">
              {{ row.status === 0 ? '已退票作废' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="form-title mt-20 mb-15" style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <span :class="['label', djMode === 'refund' ? 'yellow' : 'green']">{{ djMode === 'refund' ? '退' : '登' }}</span>
          <span class="left">{{ djMode === 'refund' ? '登记退票 (红字发票冲销)' : '登记发票 (正常开票)' }}</span>
        </div>
        <el-radio-group v-model="djMode" size="small" @change="handleDjModeChange">
          <el-radio-button label="normal">正常开票</el-radio-button>
          <el-radio-button label="refund" :disabled="!hasPositiveInvoices">登记退票</el-radio-button>
        </el-radio-group>
      </div>
      <el-alert
        v-if="djMode === 'refund'"
        title="退票提示：登记退票用于红字冲销已开具的发票。系统将自动冲销作废选中的原发票，并将本次退票金额自动记为负数冲减已开票额。"
        type="warning"
        :closable="false"
        show-icon
        class="mb-15"
      />
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <el-form-item v-if="djMode === 'refund'" label="选择冲销原发票" required>
          <el-select
            v-model="ruleForm.originDetailId"
            placeholder="请选择需要退票冲销的原发票"
            style="width: 100%"
            @change="handleOriginInvoiceChange"
          >
            <el-option
              v-for="item in positiveInvoices"
              :key="item.id"
              :label="`发票号码: ${item.no} | 金额: ¥${item.amount} | 开票日期: ${item.date || '-'}`"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="djMode === 'normal'" label="扫码抢" prop="invoiceNumber">
          <el-input
            v-model="ruleForm.invoiceNumber"
            type="textarea"
            class="filter-item"
            @keyup.enter="handleBarCodeChange"
            style="width:700px"></el-input>
        </el-form-item>
        <div class="underlineForm">
          <el-form-item :label="djMode === 'refund' ? '退票号码 / 红字发票号' : '发票号码'" prop="no">
            <el-input v-model="ruleForm.no" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票代码" prop="code">
            <el-input v-model="ruleForm.code" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票校验码" prop="checkCode">
            <el-input v-model="ruleForm.checkCode" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item :label="djMode === 'refund' ? '退票金额' : '发票金额'" prop="amount">
            <el-input v-model="ruleForm.amount" type="input" class="filter-item" :disabled="djMode === 'refund'" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item :label="djMode === 'refund' ? '退票日期' : '开票日期'" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dengjiVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="handleDJ"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-if="djInfoVisible"
      v-model="djInfoVisible"
      title="查看开票信息"
      width="80%"
    >
      <el-table :data="DJTableData" border style="width: 100%;" max-height="400px">
        <el-table-column label="发票号码" prop="no" min-width="120"/>
        <el-table-column label="发票代码" prop="code" min-width="120"/>
        <el-table-column label="发票校验码" prop="checkCode" min-width="180"/>
        <el-table-column label="开票日期" prop="date" min-width="120"/>
        <el-table-column label="发票金额" prop="amount" align="right" min-width="120">
          <template #default="{ row }">
            <span :style="{ color: row.amount < 0 || row.type === '退票' ? '#E6A23C' : '#67C23A', fontWeight: 'bold' }">
              {{ $currency(row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="发票类型" prop="type" width="110" align="center">
          <template #default="{ row }">
            <el-tag :type="row.type === '退票' || row.amount < 0 ? 'warning' : 'success'" size="small">
              {{ row.type === '退票' || row.amount < 0 ? '退票' : '正常发票' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="登记日期" prop="createTime" min-width="140" />
        <el-table-column label="状态" prop="status" width="110" align="center">
          <template #default="{ row }">
            <el-tag :type="row.status === 0 ? 'info' : 'success'" size="small">
              {{ row.status === 0 ? '已退票作废' : '正常' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
      <span class="dialog-footer">
          <el-button type="danger" @click="djInfoVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 审批取消 -->
    <div v-if="approvalCancelVisible">
      <FormComponent
        :id="activeId"
        :dialogFormVisible="approvalCancelVisible"
        :api="'invoice'"
        :isShowCloseBtn="false"
        :isShowSubmitBtn="false"
        :formDisabled="true"
        mode="approval"
      />
      <div class="dialog-footer mt-20">
        <el-button @click="approvalCancelVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          @click="handleApprove('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          @click="handleApprove('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
    <!-- 审批取退回-->
    <div v-if="approvalBackVisible">
      <FormComponent
        :id="activeId"
        :dialogFormVisible="approvalBackVisible"
        :api="'invoice'"
        :isShowCloseBtn="false"
        :isShowSubmitBtn="false"
        :formDisabled="true"
        mode="approval"
      />
      <div class="dialog-footer mt-20">
        <el-button @click="approvalBackVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          @click="handleApprove('approve', 'back')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          @click="handleApprove('reject', 'back')"
        >
          拒绝
        </el-button>
      </div>
    </div>
    <el-button type="primary" circle @click="handleSubMenuCollapse" class="subMenuCollapseBtn" v-if="!dialogFormVisible && !approvalCancelVisible && !approvalBackVisible"> {{isSubMenuCollapse ? '展开' : '收起'}}</el-button>
  </div>
</template>

<script lang='ts'>
import TableSplitter from '@/components/common/TableSplitter.vue'
import { useTableSplitter } from '@/composables/useTableSplitter'
import { defineComponent, reactive, toRefs, onMounted, unref, nextTick, ref, watch } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById, getPageList, putUrl } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { rejectInvoice, invoiceDetail, invoiceDJList } from '@/apis/invoice'
import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'

import FormComponent from './From.vue'
import TableList from '@/components/common/TableList.vue'
import TraceInfo from '@/components/traceInfo/Index.vue'
import LogisticTable from '@/views/logistics/components/Table.vue'
import BusinessInfo from '@/views/order/businessInfo/Index.vue'

import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { defaultDate, Today, pageVo, pageSizes } from '@/utils/index'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import CommandRender from '@/components/common/CommandRender.vue'

export default defineComponent({
  name: 'Invoice',
  components: {
    TableSplitter,
    FormComponent,
    TableList,
    TraceInfo,
    BusinessInfo,
    LogisticTable,
    CommandRender
  },
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)
    const tableDataRef = ref([])

    const dataMap = reactive({
      TableName: TableName.TABLE_INVOICE,
      permissionName: permissionName.INVOICE,
      columnAllData: TableField,

      activeId: 0,
      activeRate: 0,
      activeRow: {},
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessBrand: undefined,
        businessModel: undefined,
        customerCompany: undefined,
        salesManId: undefined,
        status: undefined,
        startTime: '',
        endTime: '',
        ...pageVo

      },
      dialogFormVisible: false,
      statusOption: [],
      salesManOption: [],
      btnList: [],
      pageSizes,
      tabList: [
        { name: '业务信息', id: 2 }
        // { name: '物流信息', id: 1 },
        // { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 2,
      dengjiVisible: false,
      djInfoVisible: false,
      djMode: 'normal',
      positiveInvoices: [],
      hasPositiveInvoices: false,
      DJTableData: [],
      ruleForm: {
        invoiceNumber: '',
        no: '',
        code: '',
        checkCode: '',
        amount: 0,
        date: Today,
        type: 1,
        originDetailId: undefined as any
      },
      rules: {
        invoiceNumber: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        no: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        code: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        amount: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        checkCode: [{ required: false, message: '请填写必填项', trigger: 'change' }],
        date: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      approvalCancelVisible: false,
      approvalBackVisible: false,
      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        if (command !== 'column') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'reject':
            dataMap.handleReject(val)
            break
          case 'dengji':
            invoiceDJList(dataMap.activeId).then((res: any) => {
              dataMap.DJTableData = res || []
              dataMap.updatePositiveInvoices()
              let num = 0
              dataMap.DJTableData.forEach((item: any) => {
                num += item.amount
              })
              dataMap.activeRate = val.rate
              dataMap.dengjiVisible = true
              const remaining = val.amount - num
              if (remaining <= 0 && dataMap.hasPositiveInvoices) {
                dataMap.handleDjModeChange('refund')
              } else {
                dataMap.djMode = 'normal'
                dataMap.ruleForm = {
                  invoiceNumber: '',
                  no: '',
                  code: '',
                  checkCode: '',
                  amount: remaining > 0 ? remaining : 0,
                  date: Today,
                  type: 1,
                  originDetailId: undefined
                }
              }
            })
            break
          case 'djInfo':
            invoiceDJList(dataMap.activeId).then((res: any) => {
              dataMap.DJTableData = res
              dataMap.djInfoVisible = true
            })

            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'cancel':
            dataMap.handleCancel(val)
            break
          case 'approval-cancel':
            dataMap.approvalCancelVisible = true
            break
          case 'approval-back':
            dataMap.approvalBackVisible = true
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        // invoice/page
        getPageList('invoice', { ...dataMap.listQuery, pageType: 2 }).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessBrand: undefined,
          businessModel: undefined,
          customerCompany: undefined,
          salesManId: undefined,
          status: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleReject(row: any) {
        ElMessageBox.prompt(
          '退回理由：',
          '提交',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            cancelButtonClass: 'el-button--danger'
          }
        ).then((params: any) => {
          const { value } = params
          rejectInvoice(row.id, { comment: value }).then(() => {
            dataMap.getList()
            ElMessage({
              message: '提交成功',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      updatePositiveInvoices() {
        dataMap.positiveInvoices = (dataMap.DJTableData || []).filter((item: any) => item.amount > 0 && item.status !== 0)
        dataMap.hasPositiveInvoices = dataMap.positiveInvoices.length > 0
      },
      handleDjModeChange(mode: any) {
        dataMap.djMode = mode
        if (mode === 'refund') {
          dataMap.ruleForm.type = -1
          dataMap.updatePositiveInvoices()
          if (dataMap.positiveInvoices.length === 1) {
            dataMap.handleOriginInvoiceChange(dataMap.positiveInvoices[0].id)
          } else {
            dataMap.ruleForm.originDetailId = undefined
            dataMap.ruleForm.no = ''
            dataMap.ruleForm.code = ''
            dataMap.ruleForm.checkCode = ''
            dataMap.ruleForm.amount = 0
          }
        } else {
          dataMap.ruleForm.type = 1
          dataMap.ruleForm.originDetailId = undefined
          let num = 0
          dataMap.DJTableData.forEach((item: any) => {
            num += item.amount
          })
          const remaining = (dataMap.activeRow as any).amount - num
          dataMap.ruleForm.amount = remaining > 0 ? remaining : 0
          dataMap.ruleForm.no = ''
          dataMap.ruleForm.code = ''
          dataMap.ruleForm.checkCode = ''
        }
        dataMap.clearValidate()
      },
      handleOriginInvoiceChange(id: any) {
        dataMap.ruleForm.originDetailId = id
        const target = (dataMap.DJTableData || []).find((item: any) => item.id === id)
        if (target) {
          dataMap.ruleForm.no = target.no ? (target.no.endsWith('-退') ? target.no : `${target.no}-退`) : ''
          dataMap.ruleForm.code = target.code || ''
          dataMap.ruleForm.checkCode = target.checkCode || ''
          dataMap.ruleForm.amount = Math.abs(target.amount)
          dataMap.ruleForm.date = Today
        }
      },
      handleBarCodeChange() {
        // 01,10,031002000411,51548062,924.53,20211223,62768369661843286906,92A4
        const value = dataMap.ruleForm.invoiceNumber
        const code = value.split(',') || []
        dataMap.ruleForm.no = code[2]
        dataMap.ruleForm.code = code[3]
        dataMap.ruleForm.checkCode = code[6]
        const amount = Number(code[4])
        dataMap.ruleForm.amount = Math.floor(amount * ((Number(dataMap.activeRate) + 100) / 100))
        dataMap.ruleForm.date = `${code[5].slice(0, 4)}-${code[5].slice(4, 6)}-${code[5].slice(6, 8)}`
      },
      handleDJ() {
        if (dataMap.djMode === 'refund' && !dataMap.ruleForm.originDetailId) {
          return ElMessage.error('请选择需要冲销的原发票')
        }
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tempData = { ...dataMap.ruleForm }
              if (dataMap.djMode === 'refund') {
                tempData.type = -1
              } else {
                tempData.type = 1
                tempData.originDetailId = undefined
              }
              await invoiceDetail(dataMap.activeId, tempData)
              dataMap.getList()
              ElMessage({
                message: '提交成功',
                type: 'success',
                duration: 1000
              })
              dataMap.dengjiVisible = false
            } catch (err: any) {
              console.log(err)
            }
          }
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        ).then(() => {
          deleteById('invoice', row.id).then(() => {
            dataMap.getList()
            ElMessage({
              message: '删除成功',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      handleCancel(row: any) {
        ElMessageBox.confirm(
          '是否确定要作废发票',
          '提示',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        ).then(() => {
          putUrl(`invoice/${row.id}/actions/cancel/approve`).then(() => {
            dataMap.getList()
            ElMessage({
              message: '作废成功！',
              type: 'success',
              duration: 1000
            })
          })
        })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/InvoiceStatus').then((res: any) => {
          dataMap.statusOption = res ? res.filter((k: any) => ![-1, 2].includes(k.id)) : []
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      async handleApprove(type: string, approvalType: any) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt('请输入原因', '提示', {
              confirmButtonText: '提交',
              cancelButtonText: '取消',
              cancelButtonClass: 'el-button--danger'
            }).then(async(content: any) => {
              if (content.action === 'confirm') {
                const api = approvalType === 'back'
                  ? `invoice/${dataMap.activeId}/actions/rejectBack`
                  : `invoice/${dataMap.activeId}/actions/cancel/reject`
                await putUrl(api, { comment: content.value })
                dataMap.approvalCancelVisible = false
                dataMap.approvalBackVisible = false

                dataMap.getList()
                ElMessage.success('操作成功！')
              }
            })
          } else if (type === 'approve') {
            const api = approvalType === 'back'
              ? `invoice/${dataMap.activeId}/actions/approveBack`
              : `invoice/${dataMap.activeId}/actions/cancel/approve`
            await putUrl(api)
            dataMap.approvalCancelVisible = false
            dataMap.approvalBackVisible = false
            dataMap.getList()
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      tableCellClassName({ row }: any) {
        const obj = {
          待开票: 'row-red',
          部分开票: 'row-red',
          已作废: 'row-gray',
          待确认作废: 'row-yellow'
        }
        // const changeColor = row.invoiceChanged ? 'row-orange' : ''
        // const changeDays = row.changedIn30Days ? 'row-blue' : ''

        return obj[row.statusValue] || ''
      }
    })

    const { mixinData } = mixin(dataMap)

    const splitter = useTableSplitter({
      storageKey: 'erp.split_ratio./invoice/Index',
      defaultRatio: 0.38,
      minTopHeight: 140,
      minBottomHeight: 0,
      splitterHeight: 22,
      paginationHeight: 52,
      onResize: (topH) => {
        dataMap.newHpx = topH
      }
    })

    watch(() => mixinData.isFilterCollapse, () => {
      setTimeout(() => {
        splitter.applyLayout()
      }, 50)
    })
    onMounted(() => {
      mixinData.initHeight()
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
      dataMap.btnList = [
        // {
        //   pkey: `${dataMap.permissionName}_EDIT`,
        //   name: '查看',
        //   command: 'edit'
        // },
        {
          pkey: `${dataMap.permissionName}_DJ`,
          name: '发票登记/退票',
          command: 'dengji',
          visible: (row: any) => {
            return [1, 3, 4].includes(row.status) && row.applyCancelStatus !== 1
          }
        },
        {
          pkey: `${dataMap.permissionName}_APP_BACK`,
          name: '审批申请',
          command: 'approval-back',
          type: 'danger',
          visible: (row: any) => {
            return row.status === 2
          }
        }, {
          pkey: `${dataMap.permissionName}_APPROVAL`,
          name: '审批作废',
          command: 'approval-cancel',
          type: 'danger',
          visible: (row: any) => {
            return row.applyCancelStatus === 1 && ![999].includes(row.status)
          }
        }

        // {
        //   pkey: `${dataMap.permissionName}_DJINFO`,
        //   name: '开票信息',
        //   command: 'djInfo'
        // },
        // {
        //   pkey: `${dataMap.permissionName}_REJECT`,
        //   name: '退回申请',
        //   command: 'return',
        //   type: 'danger'
        // }, {
        //   pkey: `${dataMap.permissionName}_CANCEL`,
        //   name: '发票作废',
        //   command: 'cancel',
        //   type: 'danger'
        // }, {
        //   pkey: `${dataMap.permissionName}_APPROVAL`,
        //   name: '审批取消',
        //   command: 'approval-cancel',
        //   type: 'danger'
        // }, {
        //   pkey: `${dataMap.permissionName}_DELETE`,
        //   name: '删除',
        //   command: 'delete',
        //   type: 'danger'
        // }
      ]
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData),
      ...splitter,
      handleSubMenuCollapse: splitter.toggleSubMenuCollapse, dataForm, tableDataRef }
  }
})
</script>
<style lang="scss">

</style>
